module.exports = __webpack_public_path__ + "static/media/blowfishy_head.90372a80.png";